import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import CompanyLogo from '../../../assets/images/logo.png';
import Footer from '../../../components/Footer';
import styles from './PartnerRegistration.module.scss';

// Configuration data
const COMPANY_TYPES = [
  { label: 'Proprietorship', value: 'Propreitorship' },
  { label: 'Private Limited (PVT Ltd)', value: 'Private Limited ( PVT Ltd )' },
  { label: 'Limited Liability Partnership (LLP)', value: 'Limited Liability Partnership ( LLP )' },
  { label: 'Limited', value: 'Limited' },
];

const ADDRESS_TYPES = [
  'Head Office',
  'Branch Office',
  'Billing Address',
  'Shipping Address',
  'Warehouse Address',
];

const SALUTATIONS = ['Mr', 'Mrs', 'Ms', 'Miss'];

const DEPARTMENTS = [
  'Sales',
  'Pre Sales',
  'Accounts',
  'Admin',
  'Deployment',
  'Management',
];

const INDUSTRY_VERTICAL_OPTIONS = [
  { label: 'IT & ITES', value: 'IT & ITES' },
  { label: 'BFSI', value: 'BFSI' },
  { label: 'GOVT', value: 'GOVT' },
  { label: 'Heavy Manufacturing 1', value: 'Heavy Manufacturing 1' },
  { label: 'Light Manufacturing 2', value: 'Light Manufacturing 2' },
  { label: 'Education', value: 'Education' },
  { label: 'Healthcare & Pharmaceuticals', value: 'Healthcare & Pharmaceuticals' },
  { label: 'Media', value: 'Media' },
  { label: 'Entertainment & Broadcasting', value: 'Entertainment & Broadcasting' },
  { label: 'Retail', value: 'Retail' },
  { label: 'Real Estate & Construction', value: 'Real Estate & Construction' },
  { label: 'Residential', value: 'Residential' },
  { label: 'Oil & Gas', value: 'Oil & Gas' },
  { label: 'Power & Energy', value: 'Power & Energy' },
  { label: 'Hospitality & Tourism', value: 'Hospitality & Toursim' },
  { label: 'Transportation & Logistics', value: 'Transportation & Logistics' },
  { label: 'FMCG', value: 'FMCG' },
  { label: 'Sports', value: 'Sports' },
  { label: 'Railway', value: 'Railway' },
  { label: 'Defence & Paramilitary', value: 'Defence & Paramilitary' },
  { label: 'Professional Services', value: 'Professional Services' },
  { label: 'Others', value: 'Others' },
  { label: 'All Types Industry Focus', value: 'All Types Industry Focus' },
];

const ELV_PRODUCT_OPTIONS = [
  { label: 'Access Control', value: 'Access Control' },
  { label: 'CCTV', value: 'CCTV' },
  { label: 'Fire Alarm System - FAS', value: 'Fire Alarm System -FAS' },
  { label: 'Public Address System', value: 'Public Address System' },
  { label: 'Fire Protection Solution - FPS', value: 'Fire Protection Solution - FPS' },
  { label: 'Entrance Access Control', value: 'Entrance Access Control' },
  { label: 'All of the above', value: 'All ELV Product Line' },
  { label: 'Others', value: 'Others' },
];

const SALES_SERVICES_OPTIONS = [
  { label: 'Security ELV - SI', value: 'Security ELV - SI' },
  { label: 'IT & ITES + Security', value: 'IT & ITES + Security' },
  { label: 'Turnkey Multi Package SI', value: 'Turnkey Multi Package SI' },
  { label: 'General Contractors', value: 'General Contractors' },
  { label: 'Technical Design Consultants (ELV)', value: 'Technical Design Consultants (ELV)' },
  { label: 'Cost Consultants', value: 'Cost Consultants' },
  { label: 'PMC Consultants', value: 'PMC Consultants' },
  { label: 'MEP Consultants', value: 'MEP Consultants' },
  { label: 'Electrical Consultants', value: 'Electrical Consultants' },
  { label: 'HVAC Consultants', value: 'HVAC Consultants' },
  { label: 'Global Capability Center - GCC', value: 'Global Capability Center - GCC' },
  { label: 'Fire Protection Design Consultants - FPS', value: 'Fire Protection Design Consultants - FPS' },
  { label: 'IT (ICT) Consultant', value: 'IT (ICT) Consultant' },
  { label: 'Civil Engineering Consultant', value: 'Civil Engineering Consultant' },
  { label: 'Architects - Interior Design', value: 'Architects - Interior Design' },
  { label: 'HRMS / Payroll (Software) Companies', value: 'HRMS / Payroll ( Software)Companies' },
  { label: 'HR Consultants', value: 'HR Consultants' },
  { label: 'Contractor - Manpower / Labour', value: 'Contractor - Manpower / Labour' },
  { label: 'Facility Management', value: 'Facility management' },
  { label: 'Physical Security Guard Services', value: 'Physical Security Gaud Services' },
  { label: 'Others', value: 'Others' },
];

const REGION_OPTIONS = [
  { label: 'North', value: 'North' },
  { label: 'South', value: 'South' },
  { label: 'East', value: 'East' },
  { label: 'West', value: 'West' },
  { label: 'Pan India', value: 'Pan India' },
  { label: 'Others', value: 'Others' },
];

const PARTNER_CAPABILITY_OPTIONS = [
  { label: 'Dedicated Sales', value: 'Dedicated Sales' },
  { label: 'Dedicated Pre-Sales', value: 'Dedicated Pre-Sales' },
  { label: 'Dedicated Design Team (CAD)', value: 'Dedicated Design Team (CAD)' },
  { label: 'Dedicated Support Team', value: 'Dedicated Support Team' },
  { label: 'Dedicated Project Execution Team', value: 'Dedicated Project Execution Team' },
];

const TRAINING_OPTIONS = [
  { label: 'Sales Team Training', value: 'Sales Team Tranning' },
  { label: 'Deployment Team Training', value: 'Deployment Team Tranning' },
  { label: 'Webinar Session', value: 'WEBX sessions' },
];

const ACCESS_CONTROL_OPTIONS = [
  { label: 'Matrix Comsec', value: 'Matrix Comsec' },
  { label: 'HID', value: 'HID' },
  { label: 'Mantra Softech', value: 'Mantra Softech' },
  { label: 'eSSL Security', value: 'eSSL Security' },
  { label: 'Spectra', value: 'Spectra' },
  { label: 'Realtime Biometrics', value: 'Realtime Biometrics' },
  { label: 'Fortuna', value: 'Fortuna' },
  { label: 'Dorset', value: 'Dorset' },
  { label: 'Biomax', value: 'Biomax' },
  { label: 'TimeWatch', value: 'TimeWatch' },
  { label: 'IDQube', value: 'IDQube' },
  { label: 'Others', value: 'Others' },
];

// Helper: Custom MultiSelect Component with search, chips, and click-outside
const MultiSelect = ({
  options = [],
  selected = [],
  onChange,
  placeholder = 'Click to select',
  hasError = false,
  errorMessage = '',
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleToggle = () => setIsOpen((prev) => !prev);

  const handleCheckboxChange = (value) => {
    if (selected.includes(value)) {
      onChange(selected.filter((item) => item !== value));
    } else {
      onChange([...selected, value]);
    }
  };

  const filteredOptions = options.filter((opt) =>
    opt.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const selectedLabels = selected
    .map((val) => {
      const match = options.find((opt) => opt.value === val);
      return match ? match.label : val;
    })
    .filter(Boolean);

  return (
    <div className={styles.multi} ref={wrapperRef}>
      <div
        className={`${styles.multiToggle} ${isOpen ? styles.open : ''}`}
        onClick={handleToggle}
      >
        {selected.length > 0 ? (
          <div className={styles.chips}>
            {selectedLabels.slice(0, 3).map((lbl, idx) => (
              <span key={idx} className={styles.chip}>
                {lbl}
              </span>
            ))}
            {selectedLabels.length > 3 && (
              <span className={styles.chip}>+{selectedLabels.length - 3}</span>
            )}
          </div>
        ) : (
          <span className={styles.placeholder}>{placeholder}</span>
        )}
        <span className={styles.arrow}>{isOpen ? '▲' : '▼'}</span>
      </div>

      {isOpen && (
        <div className={styles.multiMenu}>
          <div className={styles.multiSearch}>
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              autoFocus
            />
          </div>
          <div>
            {filteredOptions.length > 0 ? (
              filteredOptions.map((opt) => {
                const isChecked = selected.includes(opt.value);
                return (
                  <label
                    key={opt.value}
                    className={`${styles.option} ${isChecked ? styles.selected : ''}`}
                  >
                    <input
                      type="checkbox"
                      checked={isChecked}
                      onChange={() => handleCheckboxChange(opt.value)}
                    />
                    <span>{opt.label}</span>
                  </label>
                );
              })
            ) : (
              <div style={{ padding: '12px', fontSize: '13px', color: '#8795a1' }}>
                No options found
              </div>
            )}
          </div>
        </div>
      )}

      {hasError && errorMessage && (
        <div className={styles.errorText}>{errorMessage}</div>
      )}
    </div>
  );
};

const createEmptyAddress = () => ({
  id: Date.now() + Math.random(),
  addressType: '',
  addressGST: '',
  address: '',
  state: '',
  city: '',
  zipcode: '',
  gstFileName: '',
});

const createEmptyContact = () => ({
  id: Date.now() + Math.random(),
  salutation: '',
  firstName: '',
  lastName: '',
  mobile: '',
  email: '',
  designation: '',
  department: '',
  officeBoard: '',
});

const PartnerRegistration = () => {
  const location = useLocation();

  // Freshsales CRM Bridge reference
  const freshsalesScriptLoaded = useRef(false);
  const gstFileRef = useRef(null);
  const panFileRef = useRef(null);
  const addressGstFileRefs = useRef({});

  // 1. Company Details
  const [companyName, setCompanyName] = useState('');
  const [companyType, setCompanyType] = useState('');
  const [gst, setGst] = useState('');
  const [gstFileName, setGstFileName] = useState('');
  const [pan, setPan] = useState('');
  const [panFileName, setPanFileName] = useState('');
  const [cin, setCin] = useState('');
  const [website, setWebsite] = useState('');
  const [established, setEstablished] = useState('');

  // 2. Financial Data
  const [financial1, setFinancial1] = useState('');
  const [financial2, setFinancial2] = useState('');
  const [financial3, setFinancial3] = useState('');

  // 3. Addresses
  const [addresses, setAddresses] = useState([createEmptyAddress()]);

  // 4. Contacts
  const [contacts, setContacts] = useState([createEmptyContact()]);

  // 5. Sales & Services
  const [industryVertical, setIndustryVertical] = useState([]);
  const [industryVerticalOther, setIndustryVerticalOther] = useState('');

  const [elvProduct, setElvProduct] = useState([]);
  const [elvProductOther, setElvProductOther] = useState('');

  const [salesServices, setSalesServices] = useState([]);
  const [salesServicesOther, setSalesServicesOther] = useState('');

  const [regionOfOperations, setRegionOfOperations] = useState([]);
  const [regionOther, setRegionOther] = useState('');

  const [l1Support, setL1Support] = useState('');
  const [industryExperience, setIndustryExperience] = useState('');
  const [cloudExperience, setCloudExperience] = useState('');

  const [partnerCapabilities, setPartnerCapabilities] = useState([]);
  const [trainingRequired, setTrainingRequired] = useState([]);

  const [accessControlMake, setAccessControlMake] = useState([]);
  const [accessControlMakeOther, setAccessControlMakeOther] = useState('');

  const [channelSalesManager, setChannelSalesManager] = useState('');
  const [isCsmReadOnly, setIsCsmReadOnly] = useState(false);

  // Status & Submissions
  const [crmStatus, setCrmStatus] = useState({ message: '', isError: false });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [successNote, setSuccessNote] = useState('');
  const [validationErrors, setValidationErrors] = useState({});
  const [debugReport, setDebugReport] = useState(null);
  const [isDebugLoading, setIsDebugLoading] = useState(false);
  const isDebug = new URLSearchParams(location.search).get('debug') === '1';

  // Prepopulate CSM from query param (?csm=Name)
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const csm = (params.get('csm') || '').trim();
    if (csm) {
      setChannelSalesManager(csm);
      setIsCsmReadOnly(true);
    }
  }, [location.search]);

  // Inject Freshsales web form script dynamically with cache-busting timestamp
  useEffect(() => {
    if (freshsalesScriptLoaded.current) return;
    const container = document.getElementById('freshsalesBridge');
    if (!container) return;

    const scriptId = 'fs_caba369081702124fc4ac6d75e1497ac42c5fe6d95ff0761ac59b0e20ece9983';
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.src =
        'https://spintlyindiaprivatelimited.myfreshworks.com/crm/sales/web_forms/caba369081702124fc4ac6d75e1497ac42c5fe6d95ff0761ac59b0e20ece9983/form.js?cb=' +
        Date.now();
      script.crossOrigin = 'anonymous';
      script.id = scriptId;
      container.appendChild(script);
      freshsalesScriptLoaded.current = true;
    }
  }, []);

  // Address Handlers
  const handleAddAddress = () => {
    setAddresses((prev) => [...prev, createEmptyAddress()]);
  };

  const handleRemoveAddress = (index) => {
    if (addresses.length <= 1) return;
    setAddresses((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddressChange = (index, field, value) => {
    setAddresses((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      return updated;
    });
  };

  // Contact Handlers
  const handleAddContact = () => {
    setContacts((prev) => [...prev, createEmptyContact()]);
  };

  const handleRemoveContact = (index) => {
    if (contacts.length <= 1) return;
    setContacts((prev) => prev.filter((_, i) => i !== index));
  };

  const handleContactChange = (index, field, value) => {
    setContacts((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      return updated;
    });
  };

  // Reset all state to defaults
  const handleReset = () => {
    setCompanyName('');
    setCompanyType('');
    setGst('');
    setGstFileName('');
    setPan('');
    setPanFileName('');
    setCin('');
    setWebsite('');
    setEstablished('');

    setFinancial1('');
    setFinancial2('');
    setFinancial3('');

    setAddresses([createEmptyAddress()]);
    setContacts([createEmptyContact()]);

    setIndustryVertical([]);
    setIndustryVerticalOther('');
    setElvProduct([]);
    setElvProductOther('');
    setSalesServices([]);
    setSalesServicesOther('');
    setRegionOfOperations([]);
    setRegionOther('');
    setL1Support('');
    setIndustryExperience('');
    setCloudExperience('');
    setPartnerCapabilities([]);
    setTrainingRequired([]);
    setAccessControlMake([]);
    setAccessControlMakeOther('');

    if (!isCsmReadOnly) {
      setChannelSalesManager('');
    }

    if (gstFileRef.current) gstFileRef.current.value = '';
    if (panFileRef.current) panFileRef.current.value = '';

    setCrmStatus({ message: '', isError: false });
    setIsSuccess(false);
    setSuccessNote('');
    setIsSubmitting(false);
    setValidationErrors({});
  };

  // Test data helper
  const handleFillTestData = () => {
    setCompanyName('Test Partner Pvt Ltd');
    setCompanyType('Private Limited ( PVT Ltd )');
    setGst('29ABCDE1234F1Z5');
    setPan('ABCDE1234F');
    setCin('U12345KA2020PTC123456');
    setWebsite('https://example.com');
    setEstablished('2020');

    setFinancial1('FY 2026-27 (so far): ₹1 Cr');
    setFinancial2('FY 2025-26: ₹1.5 Cr');
    setFinancial3('FY 2024-25: ₹2 Cr');

    setAddresses([
      {
        id: 1,
        addressType: 'Head Office',
        addressGST: '29ABCDE1234F1Z5',
        address: '123 Test Street, Industrial Area',
        state: 'Karnataka',
        city: 'Bengaluru',
        zipcode: '560001',
        gstFileName: '',
      },
    ]);

    setContacts([
      {
        id: 1,
        salutation: 'Mr',
        firstName: 'Test',
        lastName: 'Partner',
        mobile: '9876543210',
        email: 'test.partner@example.com',
        designation: 'Director',
        department: 'Sales',
        officeBoard: '022 1234 5678',
      },
    ]);

    setIndustryVertical(['IT & ITES']);
    setElvProduct(['Access Control']);
    setSalesServices(['Security ELV - SI']);
    setRegionOfOperations(['South']);
    setPartnerCapabilities(['Dedicated Sales']);
    setTrainingRequired(['Sales Team Tranning']);
    setAccessControlMake(['Matrix Comsec']);

    setL1Support('Yes');
    setIndustryExperience('8 years');
    setCloudExperience('Experienced with cloud-based access control platforms and SaaS deployments.');

    if (!channelSalesManager) {
      setChannelSalesManager('Demo Sales Manager');
    }

    setValidationErrors({});
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Freshsales integration helpers
  const waitForFreshsalesForm = useCallback(async (timeoutMs = 15000) => {
    const start = Date.now();
    while (Date.now() - start < timeoutMs) {
      const form = document.querySelector(
        '#freshsalesBridge form[action*="smart_form/create_entity"]'
      );
      if (form) return form;
      await new Promise((r) => setTimeout(r, 250));
    }
    return null;
  }, []);

  const setFreshsalesField = (form, selector, value) => {
    const el = form.querySelector(selector);
    if (!el) return false;

    const values = Array.isArray(value) ? value : [value];

    if (el.tagName === 'SELECT' && el.multiple) {
      [...el.options].forEach((o) => (o.selected = values.includes(o.value)));
    } else if (el.tagName === 'SELECT') {
      el.value = values[0] ?? '';
    } else {
      el.value = value ?? '';
    }

    ['input', 'change', 'keyup', 'blur'].forEach((type) => {
      try {
        el.dispatchEvent(new Event(type, { bubbles: true, cancelable: true, composed: true }));
      } catch (_) {}
    });

    if (window.jQuery) {
      try {
        const $el = window.jQuery(el);
        $el.trigger('input').trigger('change').trigger('blur');
        if (el.tagName === 'SELECT' && $el.hasClass('select2-hidden-accessible')) {
          $el.trigger('select2:select');
        }
      } catch (_) {}
    }

    return true;
  };

  const normalizePhoneForFreshsales = (raw) => {
    let digits = String(raw || '').replace(/\D/g, '');
    if (digits.length === 10) digits = '91' + digits;
    return digits;
  };

  const setFreshsalesPhoneField = (form, selector, rawValue) => {
    const host = form.querySelector(selector);
    if (!host) return false;

    const digits = normalizePhoneForFreshsales(rawValue);

    const shadowInput = host.shadowRoot?.querySelector('input.iti__tel-input, input[type="tel"]');
    if (shadowInput) {
      shadowInput.value = digits;
      ['input', 'change', 'keyup', 'blur'].forEach((type) => {
        try {
          shadowInput.dispatchEvent(new Event(type, { bubbles: true, cancelable: true, composed: true }));
        } catch (_) {}
      });
    }

    const hiddenSibling = host.parentElement?.querySelector(`input[type="hidden"]${selector}`);
    if (hiddenSibling) {
      hiddenSibling.value = digits;
      ['input', 'change'].forEach((type) => {
        try {
          hiddenSibling.dispatchEvent(new Event(type, { bubbles: true, cancelable: true, composed: true }));
        } catch (_) {}
      });
    }

    return !!(shadowInput || hiddenSibling);
  };

  const findFreshsalesUploader = (form, labelText) => {
    const groups = [...form.querySelectorAll('.formserv-file-field')];
    const lab = (g) =>
      (g.querySelector('label')?.textContent || '').trim().toLowerCase();
    const group =
      groups.find((g) => lab(g) === labelText.toLowerCase()) ||
      groups.find((g) => lab(g).includes(labelText.toLowerCase()));
    if (!group) return null;
    return group.querySelector('fw-file-uploader-2');
  };

  const findUploaderInput = (uploader) => {
    if (!uploader) return null;
    try {
      if (uploader.shadowRoot) {
        const input = uploader.shadowRoot.querySelector('input[type="file"]');
        if (input) return input;
      }
    } catch (_) {}
    return uploader.querySelector('input[type="file"]') || null;
  };

  const copyFileToFreshsales = async (form, uploaderLabel, sourceInput, fsFiles = []) => {
    if (!sourceInput || !sourceInput.files || !sourceInput.files.length) return true;
    const names = [...sourceInput.files].map((f) => f.name);
    const uploader = findFreshsalesUploader(form, uploaderLabel);
    const target = findUploaderInput(uploader);
    if (!target) {
      fsFiles.push({
        label: uploaderLabel,
        names,
        ok: false,
        why: 'the Freshsales web form has no file field called "' + uploaderLabel + '"',
      });
      return false;
    }

    try {
      const dt = new DataTransfer();
      [...sourceInput.files].forEach((file) => dt.items.add(file));
      target.files = dt.files;
      target.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
      target.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
      if (uploader) {
        try {
          uploader.dispatchEvent(
            new CustomEvent('fwChange', {
              bubbles: true,
              composed: true,
              detail: { files: [...dt.files] },
            })
          );
        } catch (_) {}
      }
      const held = target.files && target.files.length === dt.files.length;
      fsFiles.push({
        label: uploaderLabel,
        names,
        ok: held,
        why: held ? '' : 'the file field did not keep the file',
      });
      return held;
    } catch (err) {
      console.warn('Freshsales file bridge failed:', err);
      fsFiles.push({
        label: uploaderLabel,
        names,
        ok: false,
        why: String((err && err.message) || err),
      });
      return false;
    }
  };

  const mapToFreshsales = async (freshForm) => {
    const fsLog = [];
    const fsFiles = [];

    const firstAddress = addresses[0];
    const firstContact = contacts[0];

    // Company / Account fields
    setFreshsalesField(freshForm, '[name="sales_account[name]"]', companyName);
    setFreshsalesField(freshForm, '[name="sales_account[custom_field][cf_account_type]"]', 'Partner');
    setFreshsalesField(
      freshForm,
      '[name="sales_account[custom_field][cf_channel_sales_manager]"]',
      channelSalesManager
    );
    setFreshsalesField(freshForm, '[name="sales_account[custom_field][cf_company_type]"]', companyType);
    setFreshsalesField(freshForm, '[name="sales_account[custom_field][cf_gst_number]"]', gst);
    setFreshsalesField(freshForm, '[name="sales_account[custom_field][cf_pan_number]"]', pan);
    setFreshsalesField(
      freshForm,
      '[name="sales_account[custom_field][cf_corporate_identification_number]"]',
      cin
    );
    setFreshsalesField(freshForm, '[name="sales_account[website]"]', website);
    setFreshsalesField(
      freshForm,
      '[name="sales_account[custom_field][cf_year_of_establishment]"]',
      established
    );
    setFreshsalesField(
      freshForm,
      '[name="sales_account[custom_field][cf_financial_data_1_]"]',
      financial1
    );
    setFreshsalesField(
      freshForm,
      '[name="sales_account[custom_field][cf_financial_data_2_]"]',
      financial2
    );
    setFreshsalesField(
      freshForm,
      '[name="sales_account[custom_field][cf_financial_data_3_]"]',
      financial3
    );

    // Primary address -> Freshsales Account address
    if (firstAddress) {
      const addrType =
        firstAddress.addressType === 'Warehouse Address'
          ? 'Wearhouse Address'
          : firstAddress.addressType;
      setFreshsalesField(freshForm, '[name="sales_account[custom_field][cf_address_type]"]', addrType);
      setFreshsalesField(freshForm, '[name="sales_account[custom_field][cf_gst1]"]', firstAddress.addressGST);
      setFreshsalesField(freshForm, '[name="sales_account[address]"]', firstAddress.address);
      setFreshsalesField(freshForm, '[name="sales_account[state]"]', firstAddress.state);
      setFreshsalesField(freshForm, '[name="sales_account[city]"]', firstAddress.city);
      setFreshsalesField(freshForm, '[name="sales_account[zipcode]"]', firstAddress.zipcode);
    }

    // Primary contact -> Freshsales Contact
    if (firstContact) {
      setFreshsalesField(freshForm, '[name="contact[custom_field][cf_salutation]"]', firstContact.salutation);
      setFreshsalesField(freshForm, '[name="contact[first_name]"]', firstContact.firstName);
      setFreshsalesField(freshForm, '[name="contact[last_name]"]', firstContact.lastName);
      setFreshsalesPhoneField(freshForm, '[name="contact[mobile_number]"]', firstContact.mobile);
      setFreshsalesField(freshForm, '[name="contact[email]"]', firstContact.email);
      setFreshsalesField(freshForm, '[name="contact[custom_field][cf_designation]"]', firstContact.designation);
      setFreshsalesField(freshForm, '[name="contact[custom_field][cf_department]"]', firstContact.department);
      setFreshsalesField(
        freshForm,
        '[name="contact[custom_field][cf_office_board_number]"]',
        (firstContact.officeBoard || '').trim() || 'NA'
      );
    }

    // Pick helper for single-select vs multi-select Freshsales fields
    const pickFor = (arr, cf) => {
      const el = freshForm.querySelector('[name="sales_account[custom_field][' + cf + ']"]');
      if (!el || el.multiple) return { send: arr, extra: [] };
      const offered = [...el.options].map((o) => o.value);
      const first = arr.find((v) => offered.includes(v));
      return { send: first ? [first] : [], extra: arr.filter((v) => v !== first) };
    };

    const pIndustry = pickFor(industryVertical, 'cf_industry_vertical_focus');
    const pElv = pickFor(elvProduct, 'cf_elv_product_line');
    const pSales = pickFor(salesServices, 'cf_sales__services');
    const pAc = pickFor(accessControlMake, 'cf_list_of_access_control_make_previously_handled');

    setFreshsalesField(
      freshForm,
      '[name="sales_account[custom_field][cf_industry_vertical_focus]"]',
      pIndustry.send
    );
    setFreshsalesField(
      freshForm,
      '[name="sales_account[custom_field][cf_elv_product_line]"]',
      pElv.send
    );
    setFreshsalesField(
      freshForm,
      '[name="sales_account[custom_field][cf_sales__services]"]',
      pSales.send
    );
    setFreshsalesField(
      freshForm,
      '[name="sales_account[custom_field][cf_region_of_operations_new]"]',
      regionOfOperations
    );
    setFreshsalesField(
      freshForm,
      '[name="sales_account[custom_field][cf_please_specify_others]"]',
      regionOther
    );
    setFreshsalesField(
      freshForm,
      '[name="sales_account[custom_field][cf_previous_experience_with_cloud_technology]"]',
      cloudExperience
    );
    setFreshsalesField(
      freshForm,
      '[name="sales_account[custom_field][cf_consolidated_industry_experience]"]',
      industryExperience
    );
    setFreshsalesField(
      freshForm,
      '[name="sales_account[custom_field][cf_partner_capabilities]"]',
      partnerCapabilities
    );
    setFreshsalesField(
      freshForm,
      '[name="sales_account[custom_field][cf_trainning_required]"]',
      trainingRequired
    );
    setFreshsalesField(
      freshForm,
      '[name="sales_account[custom_field][cf_capable_to_handle_l1_support]"]',
      l1Support
    );
    setFreshsalesField(
      freshForm,
      '[name="sales_account[custom_field][cf_list_of_access_control_make_previously_handled]"]',
      pAc.send
    );

    // Copy document uploads
    await copyFileToFreshsales(freshForm, 'GST', gstFileRef.current, fsFiles);
    await copyFileToFreshsales(freshForm, 'Pan', panFileRef.current, fsFiles);
    const firstAddressGstInput = addressGstFileRefs.current[firstAddress?.id];
    if (firstAddressGstInput) {
      await copyFileToFreshsales(freshForm, 'GST1', firstAddressGstInput, fsFiles);
    }

    // Merge any other "Others" text and unoffered choices into cf_please_specify_others
    const alsoPicked = [
      ['Industry', pIndustry],
      ['ELV products', pElv],
      ['Sales & services', pSales],
      ['Access control makes', pAc],
    ]
      .map(([label, pk]) =>
        pk.extra.length ? 'Also selected - ' + label + ': ' + pk.extra.join(', ') : ''
      );

    const additionalOthers = [
      industryVerticalOther,
      elvProductOther,
      salesServicesOther,
      accessControlMakeOther,
    ]
      .concat(alsoPicked)
      .filter(Boolean);

    if (additionalOthers.length) {
      const merged = [regionOther, ...additionalOthers].filter(Boolean).join(' | ');
      setFreshsalesField(
        freshForm,
        '[name="sales_account[custom_field][cf_please_specify_others]"]',
        merged
      );
    }

    // Give Select2 multi-selects a brief moment to settle
    await new Promise((r) => setTimeout(r, 300));

    // Check for any missing Freshsales required fields
    const missing = [
      ...freshForm.querySelectorAll(
        '.fserv-required input, .fserv-required select, .fserv-required textarea'
      ),
    ]
      .filter((el) => {
        if (el.type === 'file') return false;
        if (el.disabled) return false;
        if (!el.name) return false;
        if (el.tagName === 'SELECT' && el.multiple) {
          return ![...el.options].some((o) => o.selected && o.value);
        }
        return !String(el.value || '').trim();
      })
      .map(
        (el) =>
          el.closest('.fserv-field')?.querySelector('.fserv-label')?.textContent?.trim() || el.name
      )
      .filter(Boolean);

    return { missing, files: fsFiles.slice() };
  };

  // Submit Handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check custom multi-select requirements
    const errors = {};
    if (!regionOfOperations.length) {
      errors.regionOfOperations = 'Please select at least one region of operations.';
    }
    if (!trainingRequired.length) {
      errors.trainingRequired = 'Please select at least one training option.';
    }
    if (!accessControlMake.length) {
      errors.accessControlMake = 'Please select at least one access control make.';
    }

    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }
    setValidationErrors({});

    setIsSubmitting(true);
    setCrmStatus({ message: 'Submitting registration to Freshsales...', isError: false });

    const freshForm = await waitForFreshsalesForm();
    if (!freshForm) {
      setCrmStatus({
        message: 'Freshsales form could not be loaded. Please try again.',
        isError: true,
      });
      setIsSubmitting(false);
      return;
    }

    const mapped = await mapToFreshsales(freshForm);
    const missing = mapped.missing;
    const unattached = mapped.files.filter((f) => !f.ok);
    const docsNote = unattached.length
      ? 'Your ' +
        unattached.map((f) => f.label).join(', ') +
        ' document(s) could not be attached automatically — our team will contact you to collect them.'
      : '';

    if (missing.length) {
      setCrmStatus({
        message: 'Freshsales fields were not populated: ' + [...new Set(missing)].join(', '),
        isError: true,
      });
      setIsSubmitting(false);
      return;
    }

    const submitBtn = freshForm.querySelector('button[type="submit"], .fserv-button-submit');
    if (!submitBtn) {
      setCrmStatus({
        message: 'Freshsales submit button was not found.',
        isError: true,
      });
      setIsSubmitting(false);
      return;
    }

    // Click Freshsales submit button to execute its validation and AJAX submit
    submitBtn.click();

    // Poll for Freshsales response
    let checks = 0;
    const poll = setInterval(() => {
      checks++;
      const bridge = document.querySelector('#freshsalesBridge');
      const combined = (
        (bridge?.innerText || '') +
        ' ' +
        (bridge?.textContent || '')
      )
        .replace(/\s+/g, ' ')
        .trim();

      const duplicate =
        combined.match(
          /(?:cf_gst_number|GST Number|GST|Account)[^.]{0,160}(?:already exists|value is not unique)[^.]{0,180}/i
        ) || combined.match(/(?:already exists|value is not unique)[^.]{0,180}/i);

      const genericError = combined.match(
        /(?:Sorry[^.]*error|could not save[^.]*|is invalid[^.]*|Can't be empty[^.]*|cannot be blank[^.]*)/i
      );

      const success =
        /Thank you! Your information has been received|information has been received/i.test(
          combined
        );

      if (duplicate) {
        clearInterval(poll);
        setCrmStatus({
          message:
            'Freshsales rejected the registration: ' +
            duplicate[0] +
            ' Please use the existing Account or a different GST number.',
          isError: true,
        });
        setIsSubmitting(false);
        return;
      }

      if (genericError) {
        clearInterval(poll);
        setCrmStatus({
          message: 'Freshsales rejected the registration: ' + genericError[0],
          isError: true,
        });
        setIsSubmitting(false);
        return;
      }

      if (success) {
        clearInterval(poll);
        setCrmStatus({
          message: 'Registration submitted successfully to Freshsales.',
          isError: false,
        });
        setSuccessNote(docsNote);
        setIsSuccess(true);
        setIsSubmitting(false);
        setTimeout(() => {
          window.location.href = 'https://www.spintly.com';
        }, docsNote ? 6000 : 1500);
        return;
      }

      if (checks >= 40) {
        clearInterval(poll);
        setCrmStatus({
          message:
            'Freshsales did not return a response within the expected time. Please check your submission or try again.',
          isError: true,
        });
        setIsSubmitting(false);
      }
    }, 500);
  };

  const runDryRun = async () => {
    setIsDebugLoading(true);
    setDebugReport(null);
    const form = await waitForFreshsalesForm();
    if (!form) {
      setDebugReport({ error: 'The Freshsales web form did not load.' });
      setIsDebugLoading(false);
      return;
    }
    const r = await mapToFreshsales(form);
    setDebugReport(r);
    setIsDebugLoading(false);
  };

  return (
    <div className={styles.pageWrapper}>
      {/* Brand Hero Header */}
      <header className={styles.hero}>
        <div className={styles.heroInner}>
          <div className={styles.brandRow}>
            <div className={styles.brandLogoWrap}>
              <img className={styles.brandLogo} src={CompanyLogo} alt="Spintly" />
            </div>
            <div className={styles.brandDivider}></div>
            <div className={styles.brandCopy}>
              <h1>Partner Registration Form</h1>
              <p>Please share your details with us</p>
            </div>
          </div>
        </div>
      </header>

      {/* Main Registration Form */}
      <main className={styles.container}>
        {/* Freshsales hidden bridge container */}
        <div id="freshsalesBridge" className={styles.freshsalesBridge}></div>

        <form onSubmit={handleSubmit} className={styles.formCard}>
          {/* Status Banners */}
          {crmStatus.message && (
            <div
              className={`${styles.crmStatus} ${crmStatus.isError ? styles.error : ''}`}
            >
              {crmStatus.message}
            </div>
          )}

          {isSuccess && (
            <div className={styles.successBox}>
              Registration submitted successfully.{successNote ? ` ${successNote}` : ''} Taking you to www.spintly.com...
            </div>
          )}

          {/* Section 1: Company Details */}
          <section className={styles.section}>
            <div className={styles.sectionTitle}>
              <div className={styles.badge}>1</div>
              <div>
                <h2>Company Details</h2>
                <div className={styles.sub}>General business information</div>
              </div>
            </div>
            <div className={styles.grid}>
              <div className={styles.fieldGroup}>
                <label>
                  Company Name <span className={styles.req}>*</span>
                </label>
                <input
                  className={styles.input}
                  name="companyName"
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                  required
                  placeholder="Enter company name"
                />
              </div>

              <div className={styles.fieldGroup}>
                <label>
                  Company Type <span className={styles.req}>*</span>
                </label>
                <select
                  className={styles.select}
                  name="companyType"
                  value={companyType}
                  onChange={(e) => setCompanyType(e.target.value)}
                  required
                >
                  <option value="">Click to select</option>
                  {COMPANY_TYPES.map((type) => (
                    <option key={type.value} value={type.value}>
                      {type.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className={styles.fieldGroup}>
                <label>
                  GST Number <span className={styles.req}>*</span>
                </label>
                <input
                  className={styles.input}
                  name="gst"
                  value={gst}
                  onChange={(e) => setGst(e.target.value)}
                  required
                  placeholder="e.g. 27ABCDE1234F1Z5"
                />
                <div className={styles.fileUpload}>
                  <span>Upload GST Certificate</span>
                  <input
                    type="file"
                    ref={gstFileRef}
                    name="gstDocument"
                    accept=".pdf,.jpg,.jpeg,.png"
                    onChange={(e) => setGstFileName(e.target.files?.[0]?.name || '')}
                  />
                  {gstFileName && <span className={styles.fileName}>{gstFileName}</span>}
                </div>
              </div>

              <div className={styles.fieldGroup}>
                <label>
                  PAN Number <span className={styles.req}>*</span>
                </label>
                <input
                  className={styles.input}
                  name="pan"
                  value={pan}
                  onChange={(e) => setPan(e.target.value)}
                  required
                  placeholder="e.g. ABCDE1234F"
                />
                <div className={styles.fileUpload}>
                  <span>Upload PAN Card</span>
                  <input
                    type="file"
                    ref={panFileRef}
                    name="panDocument"
                    accept=".pdf,.jpg,.jpeg,.png"
                    onChange={(e) => setPanFileName(e.target.files?.[0]?.name || '')}
                  />
                  {panFileName && <span className={styles.fileName}>{panFileName}</span>}
                </div>
              </div>

              <div className={styles.fieldGroup}>
                <label>Corporate Identification Number</label>
                <input
                  className={styles.input}
                  name="cin"
                  value={cin}
                  onChange={(e) => setCin(e.target.value)}
                  placeholder="CIN / Registration number"
                />
              </div>

              <div className={styles.fieldGroup}>
                <label>Website</label>
                <input
                  className={styles.input}
                  type="url"
                  name="website"
                  value={website}
                  onChange={(e) => setWebsite(e.target.value)}
                  placeholder="https://www.company.com"
                />
              </div>

              <div className={styles.fieldGroup}>
                <label>
                  Year of Establishment <span className={styles.req}>*</span>
                </label>
                <input
                  className={styles.input}
                  type="number"
                  min="1900"
                  max="2100"
                  name="established"
                  value={established}
                  onChange={(e) => setEstablished(e.target.value)}
                  required
                  placeholder="YYYY"
                />
              </div>
            </div>
          </section>

          {/* Section 2: Financial Data */}
          <section className={styles.section}>
            <div className={styles.sectionTitle}>
              <div className={styles.badge}>2</div>
              <div>
                <h2>Financial Data</h2>
                <div className={styles.sub}>Turnover figures for past financial years</div>
              </div>
            </div>
            <div className={styles.grid3}>
              <div className={styles.fieldGroup}>
                <label>
                  Current financial year data <span className={styles.req}>*</span>
                </label>
                <input
                  className={styles.input}
                  name="financial1"
                  value={financial1}
                  onChange={(e) => setFinancial1(e.target.value)}
                  required
                  placeholder="e.g. FY 2026-27 (so far): ₹1.2 Cr"
                />
              </div>
              <div className={styles.fieldGroup}>
                <label>
                  Last financial year data <span className={styles.req}>*</span>
                </label>
                <input
                  className={styles.input}
                  name="financial2"
                  value={financial2}
                  onChange={(e) => setFinancial2(e.target.value)}
                  required
                  placeholder="e.g. FY 2025-26: ₹4.1 Cr"
                />
              </div>
              <div className={styles.fieldGroup}>
                <label>
                  Last to last financial year data <span className={styles.req}>*</span>
                </label>
                <input
                  className={styles.input}
                  name="financial3"
                  value={financial3}
                  onChange={(e) => setFinancial3(e.target.value)}
                  required
                  placeholder="e.g. FY 2024-25: ₹3.2 Cr"
                />
              </div>
            </div>
          </section>

          {/* Section 3: Address */}
          <section className={styles.section}>
            <div className={styles.sectionTitle}>
              <div className={styles.badge}>3</div>
              <div>
                <h2>Address</h2>
                <div className={styles.sub}>Office & warehouse locations</div>
              </div>
            </div>
            <div id="addressList">
              {addresses.map((addr, index) => (
                <div key={addr.id} className={styles.addressCard}>
                  <div className={styles.cardTitle}>Address {index + 1}</div>
                  {addresses.length > 1 && (
                    <button
                      type="button"
                      className={styles.removeBtn}
                      onClick={() => handleRemoveAddress(index)}
                    >
                      Remove
                    </button>
                  )}

                  <div className={styles.grid}>
                    <div className={styles.fieldGroup}>
                      <label>
                        Address Type <span className={styles.req}>*</span>
                      </label>
                      <select
                        className={styles.select}
                        value={addr.addressType}
                        onChange={(e) =>
                          handleAddressChange(index, 'addressType', e.target.value)
                        }
                        required
                      >
                        <option value="">Click to select</option>
                        {ADDRESS_TYPES.map((type) => (
                          <option key={type} value={type}>
                            {type}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className={styles.fieldGroup}>
                      <label>
                        GST Number <span className={styles.req}>*</span>
                      </label>
                      <input
                        className={styles.input}
                        value={addr.addressGST}
                        onChange={(e) =>
                          handleAddressChange(index, 'addressGST', e.target.value)
                        }
                        required
                        placeholder="Enter GST number"
                      />
                      <div className={styles.fileUpload}>
                        <span>Upload GST Certificate</span>
                        <input
                          type="file"
                          accept=".pdf,.jpg,.jpeg,.png"
                          ref={(el) => (addressGstFileRefs.current[addr.id] = el)}
                          onChange={(e) =>
                            handleAddressChange(
                              index,
                              'gstFileName',
                              e.target.files?.[0]?.name || ''
                            )
                          }
                        />
                        {addr.gstFileName && (
                          <span className={styles.fileName}>{addr.gstFileName}</span>
                        )}
                      </div>
                    </div>

                    <div className={`${styles.fieldGroup} ${styles.full}`}>
                      <label>
                        Address <span className={styles.req}>*</span>
                      </label>
                      <textarea
                        className={styles.textarea}
                        value={addr.address}
                        onChange={(e) =>
                          handleAddressChange(index, 'address', e.target.value)
                        }
                        required
                        placeholder="Building / House No., Street, Area, Landmark"
                      />
                    </div>

                    <div className={styles.fieldGroup}>
                      <label>
                        State <span className={styles.req}>*</span>
                      </label>
                      <input
                        className={styles.input}
                        value={addr.state}
                        onChange={(e) =>
                          handleAddressChange(index, 'state', e.target.value)
                        }
                        required
                        placeholder="State"
                      />
                    </div>

                    <div className={styles.fieldGroup}>
                      <label>
                        City <span className={styles.req}>*</span>
                      </label>
                      <input
                        className={styles.input}
                        value={addr.city}
                        onChange={(e) =>
                          handleAddressChange(index, 'city', e.target.value)
                        }
                        required
                        placeholder="City"
                      />
                    </div>

                    <div className={styles.fieldGroup}>
                      <label>
                        Zipcode / PIN Code <span className={styles.req}>*</span>
                      </label>
                      <input
                        className={styles.input}
                        value={addr.zipcode}
                        onChange={(e) =>
                          handleAddressChange(index, 'zipcode', e.target.value)
                        }
                        required
                        placeholder="Postal / PIN code"
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <button type="button" className={styles.addBtn} onClick={handleAddAddress}>
              + Add Another Address
            </button>
          </section>

          {/* Section 4: Contacts */}
          <section className={styles.section}>
            <div className={styles.sectionTitle}>
              <div className={styles.badge}>4</div>
              <div>
                <h2>Contacts</h2>
                <div className={styles.sub}>Point of contact persons</div>
              </div>
            </div>
            <div id="contactList">
              {contacts.map((contact, index) => (
                <div key={contact.id} className={styles.repeatCard}>
                  <div className={styles.cardTitle}>Contact {index + 1}</div>
                  {contacts.length > 1 && (
                    <button
                      type="button"
                      className={styles.removeBtn}
                      onClick={() => handleRemoveContact(index)}
                    >
                      Remove
                    </button>
                  )}

                  <div className={styles.grid}>
                    <div className={styles.fieldGroup}>
                      <label>Salutation</label>
                      <select
                        className={styles.select}
                        value={contact.salutation}
                        onChange={(e) =>
                          handleContactChange(index, 'salutation', e.target.value)
                        }
                      >
                        <option value="">Click to select</option>
                        {SALUTATIONS.map((sal) => (
                          <option key={sal} value={sal}>
                            {sal}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className={styles.fieldGroup}>
                      <label>
                        First Name <span className={styles.req}>*</span>
                      </label>
                      <input
                        className={styles.input}
                        value={contact.firstName}
                        onChange={(e) =>
                          handleContactChange(index, 'firstName', e.target.value)
                        }
                        required
                        placeholder="First name"
                      />
                    </div>

                    <div className={styles.fieldGroup}>
                      <label>
                        Last Name <span className={styles.req}>*</span>
                      </label>
                      <input
                        className={styles.input}
                        value={contact.lastName}
                        onChange={(e) =>
                          handleContactChange(index, 'lastName', e.target.value)
                        }
                        required
                        placeholder="Last name"
                      />
                    </div>

                    <div className={styles.fieldGroup}>
                      <label>
                        Mobile <span className={styles.req}>*</span>
                      </label>
                      <input
                        className={styles.input}
                        value={contact.mobile}
                        onChange={(e) =>
                          handleContactChange(index, 'mobile', e.target.value)
                        }
                        required
                        placeholder="+91 98765 43210"
                      />
                    </div>

                    <div className={styles.fieldGroup}>
                      <label>
                        Email <span className={styles.req}>*</span>
                      </label>
                      <input
                        className={styles.input}
                        type="email"
                        value={contact.email}
                        onChange={(e) =>
                          handleContactChange(index, 'email', e.target.value)
                        }
                        required
                        placeholder="name@company.com"
                      />
                    </div>

                    <div className={styles.fieldGroup}>
                      <label>
                        Designation <span className={styles.req}>*</span>
                      </label>
                      <input
                        className={styles.input}
                        value={contact.designation}
                        onChange={(e) =>
                          handleContactChange(index, 'designation', e.target.value)
                        }
                        required
                        placeholder="Designation"
                      />
                    </div>

                    <div className={styles.fieldGroup}>
                      <label>
                        Department <span className={styles.req}>*</span>
                      </label>
                      <select
                        className={styles.select}
                        value={contact.department}
                        onChange={(e) =>
                          handleContactChange(index, 'department', e.target.value)
                        }
                        required
                      >
                        <option value="">Click to select</option>
                        {DEPARTMENTS.map((dept) => (
                          <option key={dept} value={dept}>
                            {dept}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className={styles.fieldGroup}>
                      <label>Office / board number</label>
                      <input
                        className={styles.input}
                        value={contact.officeBoard || ''}
                        onChange={(e) =>
                          handleContactChange(index, 'officeBoard', e.target.value)
                        }
                        placeholder="Landline, e.g. 022 1234 5678 (leave blank if none)"
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <button type="button" className={styles.addBtn} onClick={handleAddContact}>
              + Add Another Contact
            </button>
          </section>

          {/* Section 5: Sales & Services */}
          <section className={styles.section}>
            <div className={styles.sectionTitle}>
              <div className={styles.badge}>5</div>
              <div>
                <h2>Sales & Services</h2>
                <div className={styles.sub}>Product lines, domains & operations</div>
              </div>
            </div>

            <div className={styles.grid}>
              {/* Industry Vertical Focus */}
              <div className={`${styles.fieldGroup} ${styles.full}`}>
                <label>Industry Vertical Focus</label>
                <MultiSelect
                  options={INDUSTRY_VERTICAL_OPTIONS}
                  selected={industryVertical}
                  onChange={setIndustryVertical}
                  placeholder="Click to select"
                />
                {industryVertical.includes('Others') && (
                  <div className={styles.otherSpecify}>
                    <input
                      className={styles.input}
                      value={industryVerticalOther}
                      onChange={(e) => setIndustryVerticalOther(e.target.value)}
                      placeholder="Please specify industry vertical"
                      required
                    />
                  </div>
                )}
              </div>

              {/* ELV Product Line */}
              <div className={`${styles.fieldGroup} ${styles.full}`}>
                <label>ELV Product Line</label>
                <MultiSelect
                  options={ELV_PRODUCT_OPTIONS}
                  selected={elvProduct}
                  onChange={setElvProduct}
                  placeholder="Click to select"
                />
                {elvProduct.includes('Others') && (
                  <div className={styles.otherSpecify}>
                    <input
                      className={styles.input}
                      value={elvProductOther}
                      onChange={(e) => setElvProductOther(e.target.value)}
                      placeholder="Please specify ELV product line"
                      required
                    />
                  </div>
                )}
              </div>

              {/* Sales & Services */}
              <div className={`${styles.fieldGroup} ${styles.full}`}>
                <label>Sales & Services</label>
                <MultiSelect
                  options={SALES_SERVICES_OPTIONS}
                  selected={salesServices}
                  onChange={setSalesServices}
                  placeholder="Click to select"
                />
                {salesServices.includes('Others') && (
                  <div className={styles.otherSpecify}>
                    <input
                      className={styles.input}
                      value={salesServicesOther}
                      onChange={(e) => setSalesServicesOther(e.target.value)}
                      placeholder="Please specify sales or service"
                      required
                    />
                  </div>
                )}
              </div>

              {/* Region of Operations */}
              <div className={`${styles.fieldGroup} ${styles.full}`}>
                <label>
                  Region of Operations <span className={styles.req}>*</span>
                </label>
                <MultiSelect
                  options={REGION_OPTIONS}
                  selected={regionOfOperations}
                  onChange={(val) => {
                    setRegionOfOperations(val);
                    if (val.length) {
                      setValidationErrors((prev) => ({ ...prev, regionOfOperations: '' }));
                    }
                  }}
                  placeholder="Click to select"
                  hasError={!!validationErrors.regionOfOperations}
                  errorMessage={validationErrors.regionOfOperations}
                />
                {regionOfOperations.includes('Others') && (
                  <div className={styles.otherSpecify}>
                    <label style={{ marginBottom: '5px' }}>
                      Please Specify <span className={styles.req}>*</span>
                    </label>
                    <input
                      className={styles.input}
                      value={regionOther}
                      onChange={(e) => setRegionOther(e.target.value)}
                      placeholder="Please specify your region"
                      required
                    />
                  </div>
                )}
              </div>

              {/* Capable to Handle L1 Support */}
              <div className={styles.fieldGroup}>
                <label>Capable to Handle L1 Support</label>
                <select
                  className={styles.select}
                  value={l1Support}
                  onChange={(e) => setL1Support(e.target.value)}
                >
                  <option value="">Click to select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>

              {/* Consolidated Industry Experience */}
              <div className={styles.fieldGroup}>
                <label>Consolidated Industry Experience</label>
                <input
                  className={styles.input}
                  value={industryExperience}
                  onChange={(e) => setIndustryExperience(e.target.value)}
                  placeholder="e.g. 8 years"
                />
              </div>

              {/* Cloud Technology Experience */}
              <div className={`${styles.fieldGroup} ${styles.full}`}>
                <label>Previous Experience With Cloud Technology</label>
                <textarea
                  className={styles.textarea}
                  value={cloudExperience}
                  onChange={(e) => setCloudExperience(e.target.value)}
                  placeholder="Describe your previous experience with cloud technology"
                />
              </div>

              {/* Partner Capabilities */}
              <div className={`${styles.fieldGroup} ${styles.full}`}>
                <label>Partner Capabilities</label>
                <MultiSelect
                  options={PARTNER_CAPABILITY_OPTIONS}
                  selected={partnerCapabilities}
                  onChange={setPartnerCapabilities}
                  placeholder="Click to select"
                />
              </div>

              {/* Training Required */}
              <div className={`${styles.fieldGroup} ${styles.full}`}>
                <label>
                  Training Required <span className={styles.req}>*</span>
                </label>
                <MultiSelect
                  options={TRAINING_OPTIONS}
                  selected={trainingRequired}
                  onChange={(val) => {
                    setTrainingRequired(val);
                    if (val.length) {
                      setValidationErrors((prev) => ({ ...prev, trainingRequired: '' }));
                    }
                  }}
                  placeholder="Click to select"
                  hasError={!!validationErrors.trainingRequired}
                  errorMessage={validationErrors.trainingRequired}
                />
              </div>

              {/* List of Access Control Make Previously Handled */}
              <div className={`${styles.fieldGroup} ${styles.full}`}>
                <label>
                  List of Access Control Make Previously Handled{' '}
                  <span className={styles.req}>*</span>
                </label>
                <MultiSelect
                  options={ACCESS_CONTROL_OPTIONS}
                  selected={accessControlMake}
                  onChange={(val) => {
                    setAccessControlMake(val);
                    if (val.length) {
                      setValidationErrors((prev) => ({ ...prev, accessControlMake: '' }));
                    }
                  }}
                  placeholder="Click to select"
                  hasError={!!validationErrors.accessControlMake}
                  errorMessage={validationErrors.accessControlMake}
                />
                {accessControlMake.includes('Others') && (
                  <div className={styles.otherSpecify}>
                    <input
                      className={styles.input}
                      value={accessControlMakeOther}
                      onChange={(e) => setAccessControlMakeOther(e.target.value)}
                      placeholder="Please specify access control make"
                      required
                    />
                  </div>
                )}
              </div>

              {/* Spintly Channel Sales Manager */}
              <div className={styles.fieldGroup}>
                <label>
                  Spintly Channel Sales Manager <span className={styles.req}>*</span>
                </label>
                <input
                  className={styles.input}
                  value={channelSalesManager}
                  onChange={(e) => setChannelSalesManager(e.target.value)}
                  readOnly={isCsmReadOnly}
                  required
                  placeholder="Name of your Channel Sales Manager"
                />
                {isCsmReadOnly && (
                  <div className={styles.csmNote}>
                    ✓ This registration is linked to {channelSalesManager}.
                  </div>
                )}
              </div>
            </div>
          </section>

          {/* Form Actions */}
          <div className={styles.actions}>
            <button
              type="button"
              className={`${styles.btn} ${styles.btnSecondary}`}
              onClick={handleReset}
              disabled={isSubmitting}
            >
              Reset
            </button>
            <button
              type="submit"
              className={`${styles.btn} ${styles.btnPrimary}`}
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Submitting...' : 'Submit Registration'}
            </button>
          </div>
        </form>
      </main>

      <div className={styles.footerWrapper}>
        <Footer />
      </div>

      {isDebug && (
        <div
          style={{
            position: 'fixed',
            right: '12px',
            bottom: '12px',
            zIndex: 9999,
            width: 'min(560px, 94vw)',
            maxHeight: '78vh',
            overflow: 'auto',
            background: '#ffffff',
            border: '2px solid #113852',
            borderRadius: '12px',
            boxShadow: '0 12px 40px rgba(0,0,0,0.3)',
            font: '12px/1.5 system-ui, sans-serif',
            color: '#17324a',
          }}
        >
          <div
            style={{
              padding: '10px 14px',
              background: '#113852',
              color: '#ffffff',
              fontWeight: 700,
            }}
          >
            Freshsales bridge check{' '}
            <span style={{ fontWeight: 400, opacity: 0.8 }}>
              (dry run — nothing is submitted)
            </span>
          </div>
          <div
            style={{
              padding: '10px 14px',
              display: 'flex',
              gap: '8px',
              flexWrap: 'wrap',
            }}
          >
            <button
              type="button"
              style={{ padding: '7px 12px', cursor: 'pointer' }}
              onClick={async () => {
                handleFillTestData();
                await new Promise((res) => setTimeout(res, 300));
                runDryRun();
              }}
            >
              Fill test data + dry run
            </button>
            <button
              type="button"
              style={{ padding: '7px 12px', cursor: 'pointer' }}
              onClick={runDryRun}
            >
              Dry run with my answers
            </button>
          </div>
          <div style={{ padding: '0 14px 12px' }}>
            {isDebugLoading && <div>Loading the Freshsales form…</div>}
            {debugReport && debugReport.error && (
              <b style={{ color: '#b3261e' }}>{debugReport.error}</b>
            )}
            {debugReport && !debugReport.error && (
              <div>
                <div style={{ margin: '6px 0' }}>
                  <b style={{ color: debugReport.missing.length ? '#b3261e' : '#1f7a4c' }}>
                    {debugReport.missing.length === 0
                      ? 'All required fields filled'
                      : `${debugReport.missing.length} required field(s) empty`}
                  </b>
                  {debugReport.missing.length > 0 && (
                    <div style={{ marginTop: '8px', color: '#b3261e' }}>
                      <b>Required in Freshsales but empty:</b>{' '}
                      {[...new Set(debugReport.missing)].join(', ')}
                    </div>
                  )}
                </div>
                <div style={{ marginTop: '8px' }}>
                  <b>Documents:</b>{' '}
                  {debugReport.files && debugReport.files.length ? (
                    debugReport.files.map((f, i) => (
                      <div key={i} style={{ marginTop: '3px' }}>
                        {f.label} ({f.names.join(', ')}):{' '}
                        {f.ok ? (
                          <span style={{ color: '#1f7a4c' }}>handed to Freshsales</span>
                        ) : (
                          <span style={{ color: '#b3261e' }}>
                            NOT attached — {f.why}
                          </span>
                        )}
                      </div>
                    ))
                  ) : (
                    <span>No document chosen in the form</span>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default PartnerRegistration;
